import React from "react";
import TexCell from "../atom/TexCell";

const TableRow = ({ request, onStatusChange, isSelected, onSelect }) => {
  const {
    requestId,
    createdAt,
    department,
    positionType,
    assigned,
    positionTitle,
    status,
  } = request;

  const handleRowClick = () => {
    onSelect(request);
  };

  return (
    <tr
      className={`border-t cursor-pointer hover:bg-gray-50 ${
        isSelected ? "bg-blue-100 ring-2 ring-blue-400" : "bg-white"
      }`}
      onClick={handleRowClick}
    >
      <td className="p-4">
        <input type="radio" checked={isSelected} readOnly />
      </td>

      <TexCell text={requestId || "—"} />

      <td className="px-4 py-3 text-sm text-gray-700 whitespace-nowrap">
        {createdAt && !isNaN(Date.parse(createdAt))
          ? new Date(createdAt).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "—"}
      </td>

      <TexCell text={department || "—"} />
      <TexCell text={positionType || "—"} />
      <TexCell text={assigned || "—"} />
      <TexCell text={positionTitle || "—"} />

      {/* Status: read-only + wraps to new line on small screens */}
      <td className="px-4 py-3 text-sm text-gray-700 whitespace-normal break-words max-w-[180px] sm:max-w-none">
        {status || "—"}
      </td>
    </tr>
  );
};

export default TableRow;
